<div class="sidebar-left">
    <nav class="navbar navbar-expand-sm flex-column px-0 ">
        <a class="navbar-brand nav-link p-2 mr-0" routerLink="/dashboard">
          <img class="img-fluid w-100" src="./../../assets/img/logo.png">
        </a>
        <div class="collapse navbar-collapse flex-column w-100" id="navbarContent">
          <ul class="navbar-nav flex-column w-100">
            <li class="nav-item w-100">
              <a class="nav-link active" routerLink="/dashboard">
                <i class="fa fa-dashboard"></i> Dashboard
              </a>
            </li>
          </ul>
        </div>
      </nav>
</div>
